import React from 'react';
import ReactDOM from 'react-dom';
import './index.css'; // You can create this if you want to add custom styling
import CalculatorApp from './CalculatorApp';

ReactDOM.render(
  <React.StrictMode>
    <CalculatorApp />
  </React.StrictMode>,
  document.getElementById('root')
);
